import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { apiService } from '../services';

/**
 * Componente que configura el token de autenticación en el ApiService
 * Debe estar dentro del AuthProvider para tener acceso al token
 */
const ApiTokenProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { accessToken, logout } = useAuth();

  useEffect(() => {
    // Configurar el tokenGetter en ApiService para que use el token del contexto
    apiService.setTokenGetter(() => accessToken);
    
    // Configurar el callback de logout para que ApiService pueda forzar logout
    apiService.setLogoutCallback(async () => {
      try {
        await logout();
      } catch (error) {
        console.error('Error during API-triggered logout:', error);
        // Fallback: limpiar y redirigir
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/';
      }
    });
  }, [accessToken, logout]);

  return <>{children}</>;
};

export default ApiTokenProvider;

